import request from '@/api/request.js'

export const getCategoryList = () => request({ url: '/goods/category/goods/list', method: 'get' })
 
export const getCategoryProduct = (id) => request({url:`/cate/goods/${id}`,method: 'get'})

export const getProductDetail = (id) => request({url:`/intro/${id}`,method: 'get'})